import { render, staticRenderFns } from "./LayoutNavigation.vue?vue&type=template&id=ba53cf04&scoped=true&"
var script = {}
import style0 from "./LayoutNavigation.vue?vue&type=style&index=0&id=ba53cf04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba53cf04",
  null
  
)

export default component.exports